/**
 * Single source of truth for the published legal document version.
 *
 * `clients.terms_version` records which version each client accepted. Bumping
 * TERMS_VERSION re-prompts every client on their next portal visit, so change
 * it whenever the substance of the Terms changes — that record is the evidence
 * that a specific person agreed to a specific document on a specific date.
 *
 * Keep in sync with docs/TERMS_OF_SERVICE_V62.md and re-run
 * scripts/build-legal.py after editing the source markdown.
 */
export const TERMS_VERSION = "2026-08-10";

/** Human-readable effective date shown on the public Terms page. */
export const TERMS_EFFECTIVE_DATE = "August 10, 2026";

/** Canonical public URL of the full Terms. */
export const TERMS_URL = "https://trainerpulse.app/terms";

/** Canonical public URL of the Privacy Policy. */
export const PRIVACY_URL = "https://trainerpulse.app/privacy";
